import EnrollmentProfileAPI from '@/apis/business/enrollmentProfileAPI'
import CrudBase from '@/stores/crudBase.js'
const crudBase = new CrudBase('EnrollmentProfile', EnrollmentProfileAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
  },
  mutations: {
    ...crudBase.mutations,
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,
  },
}
